import { render, staticRenderFns } from "./Feishu.vue?vue&type=template&id=1a9d7e90"
import script from "./Feishu.vue?vue&type=script&lang=js"
export * from "./Feishu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports